// Reusable share button. Uses the Web Share API when available (native mobile
// share sheet) and falls back to clipboard copy on desktop. The "Copied!" state
// flashes briefly so the user sees confirmation.
import { useState } from 'react'
import type { Locale } from '../i18n/locale'
import { t } from '../i18n/strings'

interface Props {
  locale: Locale
  className?: string
}

export default function ShareButton({ locale, className }: Props) {
  const [copied, setCopied] = useState(false)
  const onShare = async () => {
    const url = typeof window !== 'undefined' ? window.location.href : ''
    const title = typeof document !== 'undefined' ? document.title : ''
    const nav = typeof navigator !== 'undefined' ? navigator : null
    if (nav && 'share' in nav) {
      try { await nav.share({ title, url }) } catch { /* user canceled — fine */ }
      return
    }
    if (nav && nav.clipboard) {
      try {
        await nav.clipboard.writeText(url)
        setCopied(true)
        window.setTimeout(() => setCopied(false), 1800)
      } catch { /* clipboard refused — silent */ }
    }
  }
  return (
    <button
      type="button"
      onClick={onShare}
      className={className ?? 'rounded-md border border-border bg-surface px-4 py-2 text-sm font-medium text-text-body hover:bg-surface-2'}
    >
      {copied ? t(locale, 'result.linkCopied') : t(locale, 'result.share')}
    </button>
  )
}
